module.exports = __webpack_public_path__ + "static/media/settings.d7f29a28.svg";